import React from 'react'
import { Link } from 'react-router-dom'

import SearchForm from '../SearchForm/SearchForm'

import logo from '../../assets/svg/logo.svg'

import './style.scss'

const Header = props => {

  return (
    <header className="header-main">
      <Link
        to="/"
        aria-label="Navigate to the homepage"
        title="Homepage"
        className="homepage-link">
        <img
          src={logo}
          alt="corpstube"
        />
      </Link>
      <SearchForm/>
    </header>
  )
}

export default Header